import * as classnames from 'classnames/bind'
import * as React from 'react'
import { Link } from 'react-router-dom'
import styles from './brand.scss'

const cx = classnames.bind(styles)

interface IProps extends React.HTMLProps<HTMLDivElement> {
  theme: 'light' | 'dark'
}
class Brand extends React.Component<IProps> {
  public render() {
    const { theme, className } = this.props
    return (
      <Link to="/" className={cx('brand', `brand--${theme}`, className)} />
    )
  }
}

export default Brand



// WEBPACK FOOTER //
// ./src/components/Brand/index.tsx